.title {
    font-size: 22px;
    font-family: LustTextItalic;
    color: #243a5c;
    padding-top: 10px;
    padding-bottom: 5px;
}

.titleUnderline {
    border-bottom: 1px dashed #d0d5dd;
}
